import { Checkbox } from '@material-ui/core';
import { cloneDeep } from 'lodash-es';
import React from 'react';

import { Col, Cols, Row, Rows, Text, TextButton } from '~/src/dash/publicaUI';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import { publicaColors } from '~/src/dash/utils/colors';
import { IProps } from '~/src/dash/views/ias-publisher/IASReportBuilder/Report/common/types';

const renderCheckbox = (
  list: IMenuList,
  title: string,
  handleChange: (list: IMenuList, type: string) => void,
) => {
  return (
    <Rows>
      <Row
        noVerticalPadding
        extraSmallHorizontalPadding
        marginBottom='4px'
        style={{
          width: 'fit-content',
          backgroundColor: `${publicaColors.lightGray}`,
          borderRadius: '3px',
        }}
      >
        <Text small>{title}</Text>
      </Row>
      {Object.values(list).map((dimension: IListItem) => (
        <Row noPadding>
          <Cols style={{ alignItems: 'center' }}>
            <Col>
              <Checkbox
                size='small'
                checked={dimension.selected}
                onChange={() => {
                  const newIMenulist = cloneDeep(list);
                  newIMenulist[dimension.ID].selected = !dimension.selected;
                  handleChange(newIMenulist, title);
                }}
                style={{ width: '10px', marginRight: '4px' }}
              />
            </Col>
            <Col>
              <Text small>{dimension.title}</Text>
            </Col>
          </Cols>
        </Row>
      ))}
    </Rows>
  );
};

export const DimensionsRow = (props: IProps) => {
  return (
    <Rows paddingBottom='16px'>
      <Row paddingBottom='10px' noPadding>
        <TextButton size='small' onClick={props.handleClearDimensions}>
          Clear
        </TextButton>
      </Row>
      <Row noPadding>
        <Cols>
          <Col>
            {renderCheckbox(props.inventoryDimensions, 'Inventory', props.handleChangeDimension)}
          </Col>
          <Col hugeHorizontalPadding>
            {renderCheckbox(props.deliveryDimensions, 'Delivery', props.handleChangeDimension)}
          </Col>
          <Col>{renderCheckbox(props.otherDimensions, 'Other', props.handleChangeDimension)}</Col>
        </Cols>
      </Row>
    </Rows>
  );
};
